import { ContactChannelExplanationService } from 'capability-ng-notification-settings';

export class NotificationSettingsController {
  constructor(private ngContactChannelExplanationService: ContactChannelExplanationService) {}

  openExplanation() {
    this.ngContactChannelExplanationService.toggleOpen(true);
  }
}



// WEBPACK FOOTER //
// ./app/lib/my_settings/views/notification_settings/notification_settings_controller.ts